import React from 'react';
import axiosInstance from './utils/axiosinstance';

const Navigation = () => {

    const handleLogout = async () => {
        try {
            await axiosInstance.post("/api/logout/");
            localStorage.removeItem('username');
            localStorage.removeItem('csrfToken');
            window.location.href = '/login';
        } catch (error) {
            console.error('Logout error:', error);
        }
    };

    return (
        <div className="navigation-bar">
        <button className="logout-button" onClick={handleLogout}>LOGOUT</button>
      </div>
    );
};

export default Navigation;
